angular.module('wbDashboard').controller('AssetsControllerAurea', ['$scope', 'DataService', 'assetResolve', 'NgTableParams', function ($scope, DataService, assetResolve, NgTableParams) {

    if (!assetResolve) {
        $scope.$state.go('base.overview');
        return;
    }

    $scope.asset = assetResolve;

    $scope.etfDetails = new NgTableParams({
        // initial sort order
        count: 15,
        sorting: {}
    }, {
        counts: [],
        dataset: $scope.asset.assets
    });

}]);
